__turbopack_context__.v({
  "errorIcon": "componentheader-module__oEiDTq__errorIcon" + " " + "componentheader-module__oEiDTq__roundedIcon",
  "infoIcon": "componentheader-module__oEiDTq__infoIcon" + " " + "componentheader-module__oEiDTq__roundedIcon",
  "roundedIcon": "componentheader-module__oEiDTq__roundedIcon",
  "successIcon": "componentheader-module__oEiDTq__successIcon" + " " + "componentheader-module__oEiDTq__roundedIcon",
  "warningIcon": "componentheader-module__oEiDTq__warningIcon" + " " + "componentheader-module__oEiDTq__roundedIcon",
});
